import { useState } from "react";
import { HeroSection } from "./landing/HeroSection";
import { ProblemSolution } from "./landing/ProblemSolution";
import { HowItWorks } from "./landing/HowItWorks";
import { FooterCTA } from "./landing/FooterCTA";

export default function LandingPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <HeroSection mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
      <ProblemSolution />
      <HowItWorks />
      <FooterCTA />
    </div>
  );
}
